import { Button, Form, Icon, List, Modal, Text } from "../../../../components";
import Localization from "../../../../localization";
import { useApp } from "../../../../hooks";
import { SVGs } from "../../../../assets";
import { useRef } from "react";
import { Flex } from "antd";

const fields = [
  {
    name: "name",
    label: Localization.general.name,
    placeholder: Localization.placeholder.nominees_name,
    rules: [
      { required: true, message: Localization.feedback.required_nominees_name },
    ],
  },
  [
    {
      name: "phone",
      label: Localization.general.phone_number,
      rules: [{ type: "phone", required: true }],
      placeholder: Localization.general.phone_number,
    },
    {
      name: "email",
      label: Localization.general.email_address,
      placeholder: Localization.general.email_address,
      rules: [
        {
          required: true,
          type: "email",
          message: Localization.feedback.required_nominees_email,
        },
      ],
    },
  ],
  {
    name: "password",
    label: Localization.general.code_word,
    placeholder: Localization.general.code_word,
  },
  {
    face: "checkbox",
    name: "authority",
    valuePropName: "checked",
    title: Localization.general.admin,
    children: Localization.service_edit_alarm_operator.contacts_admin_desc,
  },
];

const Contacts = ({
  contacts = [],
  onNext = () => {},
  onBack = () => {},
  onAdd = () => {},
  onEdit = () => {},
  onRemove = () => {},
}) => {
  const { modal } = useApp();
  const modalRef = useRef();
  const formRef = useRef();

  const updateContact = async (index) => {
    try {
      await formRef.current.validateFields();
      const data = formRef.current.getFieldsValue({
        format: { name: "phone", key: "phone" },
      });
      data.authority = data.authority ? 5 : 1;
      !!index ? onEdit(index, data) : onAdd(data);
      modalRef.current.close();
    } catch (error) {}
  };

  const delContact = (_, index) => {
    modal.confirm({
      okText: Localization.general.yes,
      cancelText: Localization.general.no,
      title: Localization.service_edit_alarm_operator.contacts_del_modal_title,
      description: Localization.formatString(
        Localization.service.alarmSMS_modal_del_desc,
        <Text weight={600} level={"text"} color="inherit" children={_.name} />
      ),
      onOk: (modal) => {
        onRemove([index]);
        modal.destroy();
      },
    });
  };

  const renderItem = (_, index) => {
    return (
      <List.Item
        children={
          <List.Item.Meta
            title={_.title}
            description={
              <div className="m-5-t">
                <Text weight={400} type="secondary" children={_.phone} />
                <Text
                  weight={400}
                  type="secondary"
                  className="m-7-t"
                  children={_.codeWord}
                />
              </div>
            }
          />
        }
        extra={
          !_.isOwner && (
            <Flex gap={"2rem"}>
              <Text level={3} type="secondary">
                <Icon
                  onClick={() => modalRef.current.open({ index })}
                  component={SVGs.editOutlinedComp}
                />
              </Text>
              <Text level={3} type="secondary">
                <Icon
                  component={SVGs.deleteOutlinedComp}
                  onClick={() => delContact(_, index)}
                />
              </Text>
            </Flex>
          )
        }
      />
    );
  };

  return (
    <div>
      <Text
        level={5}
        weight="600"
        type="secondary"
        children={`${Localization.general.step} 2: ${Localization.service_edit_alarm_operator.contacts_title}`}
      />
      <Text
        type="secondary"
        className="m-5-t m-30-b"
        children={Localization.service_edit_alarm_operator.contacts_desc}
      />
      {contacts.length < 3 && (
        <List className="m-20-b">
          <List.Item
            onClick={() => modalRef.current.open({})}
            children={
              <List.Item.Meta
                title={{
                  type: "secondary",
                  children: Localization.general.add,
                }}
                avatar={
                  <Text level={1}>
                    <Icon component={SVGs.plusHollowCircleFilledComp} />
                  </Text>
                }
              />
            }
          />
        </List>
      )}
      <List
        dataSource={contacts}
        renderItem={renderItem}
        highlightOnHover={false}
      />
      <Flex gap={"1rem"} className="m-30-t">
        <Button
          type="primary"
          title={Localization.general.save_and_cont}
          onClick={() => onNext({})}
        />
        <Button onClick={() => onBack()} title={Localization.general.back} />
      </Flex>
      <Modal
        ref={modalRef}
        title={Localization.service_edit_alarm_operator.contacts_form_title}
        child={({ index } = {}) => {
          const contact = { ...(contacts[index] ?? {}) };
          contact.authority = contact.authority === 5;
          return (
            <div>
              <Form ref={formRef} initialValues={contact} fields={fields} />
              <Button
                type="primary"
                className="m-30-t"
                onClick={() => updateContact(index)}
                title={
                  !!index ? Localization.general.save : Localization.general.add
                }
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default Contacts;
